import React, { useState } from "react";
import Chart from "react-apexcharts";
import MyTabs from "./MyTabs";
import MyTabs2 from "./MyTabs2";

export function DailyInstallGraph({ title, graphData, days, onTabChange }) {
  const [isDark] = useState(localStorage.getItem("theme") === "dark");

  const filteredData = graphData.slice(-days);
  const categories = filteredData.map((item) => item.date);
  const allValues = [
    ...filteredData.map((i) => i.installs),
    ...filteredData.map((i) => i.register),
  ];
  const maxValue = Math.max(...allValues);

  const series = [
    {
      name: "Installs",
      data: filteredData.map((item) => item.installs),
    },
    {
      name: "Registered",
      data: filteredData.map((item) => item.register),
    },
  ];

  const options = {
    chart: {
      type: "area",
      height: 320,
      toolbar: {
        show: true,
        tools: {
          download: `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download"><path d="M12 15V3"/><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/></svg>`,

          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: true,
          reset: true,
        },
      },
      zoom: {
        enabled: false,
      },
      selection: {
        enabled: false,
      },
      animations: { enabled: true },
    },
    stroke: { curve: "smooth", width: 1.5 },
    colors: ["#4F80FF", "#00bb00"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.3,
        opacityTo: 0.05,
        stops: [0, 100],
      },
    },
    markers: {
      size: 5,

      strokeWidth: 1,
      strokeColors: "#fff",
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: isDark ? "#cbd5f5" : "#001321", // light vs dark
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      min: 0,
      max: maxValue + Math.ceil(maxValue * 0.1),
      tickAmount: 6,
      labels: {
        style: {
          colors: isDark ? "#cbd5f5" : "#001321", // light vs dark
          fontSize: "12px",
        },
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      offsetY: 0, // padding vertical
      offsetX: 0, //padding horizontal
      itemMargin: {
        horizontal: 20, //margin b/w item
        vertical: 0, //margin vertical
      },
      markers: {
        size: 6,
        offsetX: -5, // space b/w circle and lable
      },
      labels: {
        colors: isDark ? "#cbd5f5" : "#001321",
        fontSize: "20px",
      },
    },
  };

  return (
    <div className="flex flex-col  bg-white dark:bg-slate-900/80 p-4 rounded-2xl shadow-md w-full">
      <div className=" w-full flex items-start justify-between">
        <div className="flex flex-col w-full">
          <h1 className="text-[13px] font-semibold text-slate-700 dark:text-slate-200">
            {title}
          </h1>
          <span className="text-xs font-semibold text-slate-500 dark:text-slate-400">
            {"Last " + days + " Days Analytics"}
          </span>
        </div>

        <MyTabs2
          tabs={[
            { label: "7.Days", days: 7 },
            { label: "15.Days", days: 15 },
            { label: "30.Days", days: 30 },
          ]}
          onTabChange={(tab) => onTabChange(tab.days)}
        />
      </div>

      <div className="w-full">
        <div className="mt-2">
          <Chart options={options} series={series} type="area" height={320} />
        </div>
      </div>
    </div>
  );
}
